import styled from 'styled-components'

export const StyledLink = styled.a(({ theme }) => ({
  color: theme.colors.n08
}))
